<template>
    <div>
<!--        <b-navbar toggleable="md" class="navbar">-->
<!--            <b-navbar-brand class="col-md-3">-->
<!--                <img class="logo" src="http://localhost:8080/img/logo.9eec646e.jpg">-->
<!--                &lt;!&ndash; clubsaway logo &ndash;&gt;-->
<!--            </b-navbar-brand>-->
<!--        </b-navbar>-->

<!--        <div class="my-5">-->
<!--            <router-view></router-view>-->
<!--        </div>-->

<!--        <tb-footer></tb-footer>-->
        <div class="container-fluid full-height">
            <div class="row h-100">
                <div class="col-sm-6 right-col" >
                    <img class="logo" src="@/assets/clubsaway-logo-desktop.svg">
                </div>
                <div class="col-sm-6 left-col">

                    <div class="login-form">
                        <h1>
                            Login
                        </h1>

                        <b-form @submit.prevent="onSubmit()">
                            <b-form-group>
                                <label>
                                    Email Address
                                </label>

                                <b-form-input
                                        v-model="form.email"
                                        type="email"
                                        required>
                                </b-form-input>
                            </b-form-group>

                            <b-form-group>
                                <label>
                                    Password
                                </label>

                                <b-form-input
                                        v-model="form.password"
                                        type="password"
                                        required>
                                </b-form-input>
                            </b-form-group>

                            <b-button type="submit" variant="primary">
                                Login
                            </b-button>
                        </b-form>
                    </div>

<!--                       <router-link to="/invitee">Dummy Invite</router-link>-->
                </div>
            </div>
        </div>
    </div>


</template>

<script>
    import TbFooter from '@/views/Footer.vue';
    import {api} from "@/repository/repository.js";

    export default {
        components: {
            TbFooter
        },
        data(){
            return{
                form:{
                    email:'',
                    password:''
                }
            }
        },
        methods:{
            onSubmit(){
                api.post('/login', this.form)
                    .then((response)=>{
                        let user = response.data;
                        this.$store.commit('setUser', user);
                        if(user.role == 'ADMIN'){
                            this.$router.push('/admin');
                        }else{
                            this.$router.push('/client');
                        }
                    })
                    .catch((error)=>{
                        console.log(error.response);
                    })
            }
        }
    }
</script>

<style scoped lang="scss">
    .full-height{
        height: 100vh;
    }
    .right-col{
        background: url("https://clubsaway.tbclient.co.uk/wp-content/uploads/2019/01/CAgolf.jpg");
        background-size: cover;
        display: flex;
        align-items: flex-start;
        justify-content: center;

        .logo{
            margin-top: 3rem;
        }
    }
    .left-col{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .login-form{
            border:1px solid #e6e6e6;
            padding:2rem;

            h1{
                margin: -2rem -2rem 2rem -2rem;
                padding: 1rem 2rem;
                border-bottom: 1px solid #e6e6e6;
                font-size: 2rem;
                font-weight: 100;
            }
        }
    }
    a.router-link-active {
        color: white!important;
    }

    .logo {
        max-width: 300px;
    }
</style>